__turbopack_context__.v({
  "actionButton": "_7FBTLa_actionButton",
  "actionButtons": "_7FBTLa_actionButtons",
  "actionsGrid": "_7FBTLa_actionsGrid",
  "altAuth": "_7FBTLa_altAuth",
  "button": "_7FBTLa_button",
  "buttonGroup": "_7FBTLa_buttonGroup",
  "card": "_7FBTLa_card",
  "container": "_7FBTLa_container",
  "description": "_7FBTLa_description",
  "divider": "_7FBTLa_divider",
  "errorMessage": "_7FBTLa_errorMessage",
  "footerLink": "_7FBTLa_footerLink",
  "footerText": "_7FBTLa_footerText",
  "form": "_7FBTLa_form",
  "formGroup": "_7FBTLa_formGroup",
  "googleBtn": "_7FBTLa_googleBtn",
  "header": "_7FBTLa_header",
  "icon": "_7FBTLa_icon",
  "infoGrid": "_7FBTLa_infoGrid",
  "infoIcon": "_7FBTLa_infoIcon",
  "infoItem": "_7FBTLa_infoItem",
  "infoLabel": "_7FBTLa_infoLabel",
  "infoValue": "_7FBTLa_infoValue",
  "input": "_7FBTLa_input",
  "inputWithIcon": "_7FBTLa_inputWithIcon",
  "label": "_7FBTLa_label",
  "optionPlaceholder": "_7FBTLa_optionPlaceholder",
  "outlineButton": "_7FBTLa_outlineButton",
  "passwordToggle": "_7FBTLa_passwordToggle",
  "profileContent": "_7FBTLa_profileContent",
  "profileSection": "_7FBTLa_profileSection",
  "securityNote": "_7FBTLa_securityNote",
  "textareaField": "_7FBTLa_textareaField",
  "title": "_7FBTLa_title",
});
